/**
 * @desc Test
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMasterFactoryWhole/test`, {
      method: "GET",

      ...options,
    }),
  );
}
